

exports.__esModule = true;
exports.$xoFrameBustPageDirective = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getCenterPosition = getCenterPosition;

var _logger = require('xo-beaver/dist/logger');

var _uiRouter = require('uiRouter');

var _index = require('squid/index');

var _icFallback = require('js/lib/icFallback');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getCenterPosition(_ref) {
    var width = _ref.width,
        height = _ref.height;


    var left = void 0;
    var top = void 0;

    if (width) {
        if (window.outerWidth) {
            left = Math.round((window.outerWidth - width) / 2) + window.screenX;
        } else if (window.screen.width) {
            left = Math.round((window.screen.width - width) / 2);
        }
    }

    if (height) {
        if (window.outerHeight) {
            top = Math.round((window.outerHeight - height) / 2) + window.screenY;
        } else if (window.screen.height) {
            top = Math.round((window.screen.height - height) / 2);
        }
    }

    return { left: left, top: top };
}

var $xoFrameBustPageDirective = exports.$xoFrameBustPageDirective = _index.$Component.extend('$xoFrameBustPageDirective', {

    tag: 'xo-framebust-page',
    template: _template2['default'],

    props: {},

    resolve: {},

    actions: {
        submit: function submit() {

            window.xchild.hide();

            var url = decodeURIComponent(_uiRouter.$stateParams.url);

            if (_uiRouter.$stateParams.action === 'open') {

                var xprops = _extends({}, window.xprops);

                xprops.url = url;

                _logger.$logger.warn('framebust_click_to_hermes');

                return window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops);
            }

            if (_uiRouter.$stateParams.action === 'fallback') {

                _logger.$logger.warn('framebust_click_to_legacy');

                var width = 970;
                var height = 850;

                var _getCenterPosition = getCenterPosition({ width: width, height: height }),
                    left = _getCenterPosition.left,
                    top = _getCenterPosition.top;

                var win = window.open(url, 'hermes_fallback', 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left);

                (0, _icFallback.$incontextFallback)(win, url);
            }
        }
    }
});

angular.value("getCenterPosition", getCenterPosition);
angular.value("$xoFrameBustPageDirective", $xoFrameBustPageDirective);
_logger.$logger;

_uiRouter.$stateParams;

_index.$Component;

_icFallback.$incontextFallback;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-framebust/directive.js
// module id = ./pages/xo-framebust/directive.js
// module chunks = 0